import heroImage from './HeroImage';
import infographic from './Infographic';
import longformGallery from './LongformGallery';
import longformRow from './LongformRow';
import parallaxImageTextRight from './ParallaxImageTextRight';
import thumbnailCarousel from './ThumbnailCarousel';
import slideSummary from './SlideSummary';
export default {
  heroImage,
  infographic,
  longformGallery,
  longformRow,
  parallaxImageTextRight,
  thumbnailCarousel,
  slideSummary
};
//# sourceMappingURL=index.js.map